import { reduxForm } from 'redux-form';
import Component from './FormNotification';

export default reduxForm({
  form: 'notificationForm',
  initialValues: {
    type: '',
    title: '',
    content: '',
    contentImage: '',
    startDate: '',
    endDate: '',
    status: '',
  },
})(Component);
